import { render, staticRenderFns } from "./AnimalAvatarCell.vue?vue&type=template&id=c83894f8&scoped=true&"
import script from "./AnimalAvatarCell.vue?vue&type=script&lang=js&"
export * from "./AnimalAvatarCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83894f8",
  null
  
)

export default component.exports